import { createSelector } from '@reduxjs/toolkit';

import { formatToAPIDate } from '@modules/utils/datesLuxon';
import { organizationGuidSel } from '@shared/duck/selectors/general.selectors';

import { buildCompletionDateParams } from '../activityUtils';
import { updatedDateFilters } from '../constants';
import { isActivityTabCurrentSel, updatedDateFilterSel } from './selectors';

const getNewUpdatedDateFilter = (
  currentUpdatedDate: string,
  isActivtiyTabActive: boolean,
) => {
  const shouldChangeDateFilter =
    !isActivtiyTabActive && currentUpdatedDate === updatedDateFilters.ALL;
  return shouldChangeDateFilter
    ? updatedDateFilters.LAST_365_DAYS
    : currentUpdatedDate;
};

export const activitiesPayloadSel = createSelector(
  updatedDateFilterSel,
  isActivityTabCurrentSel,
  organizationGuidSel,
  (updatedDateFilter, isActivtiyTabActive, organizationGuid) => {
    const updatedDate = getNewUpdatedDateFilter(
      updatedDateFilter,
      isActivtiyTabActive,
    );
    const { completionDateStart, completionDateEnd } =
      buildCompletionDateParams(updatedDate);

    return {
      startDate: formatToAPIDate(completionDateStart),
      endDate: formatToAPIDate(completionDateEnd),
      perPage: 300,
      pageIndex: 1,
      organizationGuid,
    };
  },
);
